if (
  !process.env.REACT_APP_CLIENT_ID ||
  !process.env.REACT_APP_AUTHORITY ||
  !process.env.REACT_APP_API_SCOPE ||
  !process.env.REACT_APP_REDIRECT_URI ||
  !process.env.REACT_APP_API_URL 
  // !process.env.REACT_APP_FLUTTER_INSIGHTS_URL
) {
  throw new Error("Missing environment variables");
}

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const API_SCOPE = process.env.REACT_APP_API_SCOPE;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
export const API_URL = process.env.REACT_APP_API_URL;
export const ENV_NAME = process.env.REACT_APP_ENV_NAME;
export const FLUTTER_INSIGHTS_URL = ENV_NAME === 'dev'
  ? 'https://gpscinsight-dev.blueowl.com'
  : ENV_NAME === 'uat'
  ? 'https://gpscinsight-uat.blueowl.com'
  : 'https://gpscinsight.blueowl.com'

export const FLUTTER_REPORTS_URL = ENV_NAME === 'dev'
  ? 'https://gpscreports-dev.blueowl.com'
  : ENV_NAME === 'uat'
  ? 'https://gpscreports-uat.blueowl.com'
  : 'https://gpscreports.blueowl.com'
